"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.required = exports.label = exports.inputWrapper = exports.infoIcon = exports.hint = void 0;
Object.defineProperty(exports, "srOnly", {
  enumerable: true,
  get: function get() {
    return _feBrary.srOnly;
  }
});
exports.wrapper = void 0;
var _core = require("@emotion/core");
var _feBrary = require("@domain-group/fe-brary");
var _variables = require("./variables");
var scaleRatio = 0.6875;
var inputWrapper = exports.inputWrapper = {
  name: "79elbk",
  styles: "position:relative;"
};
var wrapper = exports.wrapper = /*#__PURE__*/(0, _core.css)("position:relative;width:100%;max-width:100%;", (0, _feBrary.applyFont)(_variables.inputWrapperFont), ";");
var label = (isFloatingLabel, inputIsFocused, inputHasValue) => /*#__PURE__*/(0, _core.css)("display:block;margin-bottom:6px;font-weight:bold;cursor:pointer;", isFloatingLabel && /*#__PURE__*/(0, _core.css)((0, _feBrary.applyFont)(_variables.labelFont), ";", _feBrary.singleLineEllipsis, ";position:absolute;z-index:1;top:", _variables.inputVPadding, "px;right:", _variables.inputHPadding, "px;bottom:0;left:", _variables.inputHPadding, "px;transform-origin:left top;transition:transform cubic-bezier(0.25,0.8,0.25,1) ", _variables.transitionDuration, ";color:", _variables.inputPlaceholderTextColor, ";pointer-events:none;", (inputIsFocused || inputHasValue) && /*#__PURE__*/(0, _core.css)("transform:translate3d(0,", _variables.inputVPadding * scaleRatio * -1 + 1, "px,0) scale(", scaleRatio, ");color:", _feBrary.tokens.colors.neutral.base.default, ";")));
exports.label = label;
var hint = exports.hint = /*#__PURE__*/(0, _core.css)(_feBrary.fontSmall, ";color:", _feBrary.tokens.colors.neutral.medium.default, ";");
var required = exports.required = /*#__PURE__*/(0, _core.css)("margin-left:3px;color:", _feBrary.tokens.colors.critical.base.default, ";speak:none;");
var infoIcon = exports.infoIcon = /*#__PURE__*/(0, _core.css)("margin-left:6px;vertical-align:-4px;", (0, _feBrary.media)('>=tablet'), "{margin-left:3px;}");